// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-contact{
    text-align: center;
    width: 17rem;
    /* float: left; */
    display: inline-block;
    margin: 0 auto;
}

.support-contact p{
    margin: 0;
}

.support-contact_city{
    color: var(--main-green-color);
}
#support-contact_graph{
    margin-top: 1rem;
}

.support-contact_line{
    display: flex;
    flex-direction: row;
}

.support-baner{
    margin-top: 5rem;
}

.support-baner_images{
    display: flex;
    height: -moz-fit-content;
    height: fit-content;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.support-baner_images img{
    height: 5rem;
}

#line{
    float: none;
    border: 2px solid black;
    height: 1px;
    width: 100%;
}

.support_green_box{
    /* width: 100%; */
    /* background-color:#3AC9B5; */
    background-color: var(--main-green-color);
    text-align: center;
    color: #fff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.support_green_box_inner{
    padding: 2rem;
}

.support_facebook-icon {
    color: var(--main-green-color);
    width: 35px;
    height: 35px;
}

.support_hr-line {
    /* color: #3AC9B5; */
    color: var(--main-green-color);
    height: 2px;
}

.support__text-h3 {
    /* color: #3AC9B5; */
    color: var(--main-green-color);
    margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/support.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;IACX,qDAAqD;AACzD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;AACpB","sourcesContent":[".support-contact{\n    text-align: center;\n    width: 17rem;\n    /* float: left; */\n    display: inline-block;\n    margin: 0 auto;\n}\n\n.support-contact p{\n    margin: 0;\n}\n\n.support-contact_city{\n    color: var(--main-green-color);\n}\n#support-contact_graph{\n    margin-top: 1rem;\n}\n\n.support-contact_line{\n    display: flex;\n    flex-direction: row;\n}\n\n.support-baner{\n    margin-top: 5rem;\n}\n\n.support-baner_images{\n    display: flex;\n    height: fit-content;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.support-baner_images img{\n    height: 5rem;\n}\n\n#line{\n    float: none;\n    border: 2px solid black;\n    height: 1px;\n    width: 100%;\n}\n\n.support_green_box{\n    /* width: 100%; */\n    /* background-color:#3AC9B5; */\n    background-color: var(--main-green-color);\n    text-align: center;\n    color: #fff;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n.support_green_box_inner{\n    padding: 2rem;\n}\n\n.support_facebook-icon {\n    color: var(--main-green-color);\n    width: 35px;\n    height: 35px;\n}\n\n.support_hr-line {\n    /* color: #3AC9B5; */\n    color: var(--main-green-color);\n    height: 2px;\n}\n\n.support__text-h3 {\n    /* color: #3AC9B5; */\n    color: var(--main-green-color);\n    margin-top: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
